export default "__VITE_ASSET__dFR2ke6o__"